const config = {
  strapiUrl: "https://content.cdg-portal.com",
  strapiAuthUrl: `https://content.cdg-portal.com/auth/local`,
  laravelUrl: "https://admin.cdg-portal.com",
};

export default config;
